export default "__VITE_ASSET__609c4b4f__"